<template>
    <div>
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-form-select v-model="reportStatus" :options="reportStatusOptions"></b-form-select>
                        <b-form-select
                                v-model="archiveOnly"
                                :options="archiveScopeOptions"
                                aria-label="Статус объекта"
                        ></b-form-select>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                responsive="sm"
                :fields="fields"
                :filter="filter"
                small
                striped
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                :busy="isBusy"
                sticky-header="80vh"
                :tbody-tr-class="reportRowClass"
        >
            <template #cell(report_status)="data">
                <b-badge v-if="isAnnulled(data.item)" variant="danger" :title="data.item.annulment_reason || ''">
                    АННУЛИРОВАН — НЕ УЧИТЫВАТЬ
                </b-badge>
                <b-badge v-else variant="success">Действующий</b-badge>
            </template>
            <template v-slot:cell(date_time_begin)="data">
                {{ Date.parse(data.item.date_time_begin) | moment("DD.MM.YYYY dd HH:mm")}}
            </template>
            <template v-slot:cell(notes)="data">
                <ul>
                    <li :key="i" v-for="(item, i) in data.item.notes.split(`-->`)">{{ item }}</li>
                </ul>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        computed: {
            items() {
                const rows = this.$store.state.usedFuels || [];
                if (this.reportStatus === `active`) return rows.filter(row => !this.isAnnulled(row));
                if (this.reportStatus === `annulled`) return rows.filter(row => this.isAnnulled(row));
                return rows;
            }
        },
        data() {
            return {
                fields: [
                    {key: `report_status`, label: `Статус отчёта`},
                    {
                        key: `shift_id`,
                        label: `Ид смены`,
                        sortable: true
                    },
                    {
                        key: `date_time_begin`,
                        label: `Время начала смены`,
                        sortable: true
                    },
                    {
                        key: `building_name`,
                        label: `Имя объекта`,
                        sortable: true
                    },
                    {
                        key: `fuel_name`,
                        label: `Имя топлива`,
                        sortable: true
                    },
                    {
                        key: `value`,
                        label: `Израсходованно`,
                        sortable: true
                    },
                    {
                        key: `unit`,
                        label: `Ед. изм.`,
                        sortable: true
                    },
                    {
                        key: `notes`,
                        label: `Примечание`,
                        sortable: true
                    },
                ],
                filter: null,
                filterOn: [],
                perPage: 200,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                isBusy: true,
                archiveOnly: false,
                archiveScopeOptions: [
                    {value: false, text: `Действующие объекты`},
                    {value: true, text: `Архив объектов`}
                ],
                reportStatus: `all`,
                reportStatusOptions: [
                    {value: `all`, text: `Все отчёты`},
                    {value: `active`, text: `Действующие`},
                    {value: `annulled`, text: `Аннулированные`}
                ]
            }
        },
        methods: {
            async loadUsedFuels() {
                this.isBusy = true;
                try {
                    await this.$store.dispatch(`getUsedFuels`, this.archiveOnly);
                    await this.$nextTick();
                    this.totalRows = this.items.length;
                    this.currentPage = 1;
                } finally {
                    this.isBusy = false;
                }
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            isAnnulled(item) {
                return Boolean(item && item.annulled_at);
            },
            reportRowClass(item) {
                return this.isAnnulled(item) ? `legacy-report-row--annulled` : ``;
            }
        },
        async mounted() {
            await this.loadUsedFuels();
        },
        watch: {
            archiveOnly() {
                this.loadUsedFuels();
            },
            reportStatus() {
                this.$nextTick(() => {
                    this.totalRows = this.items.length;
                    this.currentPage = 1;
                });
            }
        },
        name: "UsedFuels"
    }
</script>

<style scoped>

>>> tr.legacy-report-row--annulled > td {
    background: #fff3f3;
    color: #721c24;
}

</style>
